var lMap = {
    multipleModals: false,
    modalId: 'pickUpMap',
    existingModals: [],
    mapDOM: '',
    init: function() {
        $('body').on('click', '.open-map', function(e) {
            e.preventDefault();
            if (typeof $(this).data('id') !== 'undefined' && $(this).data('id') !== 'pickUpMap') {
                lMap.modalId = $(this).data('id');
                lMap.multipleModals = true;
            }
            lMap.openModal();
            lMap.closeAction();
        });
    },
    render: function() {
        var mapHandler = $('#'+lMap.modalId);
        if (typeof mapHandler.data('lat') !== 'undefined' && typeof mapHandler.data('lng') !== 'undefined') {

            var coords = {
                    lat: parseFloat(mapHandler.data('lat')),
                    lng: parseFloat(mapHandler.data('lng'))
                },
                icon = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="41.026"><path d="M16.103 0h-.308C7.077.103 0 7.385 0 16.205c0 11.897 13.95 23.18 16 24.82 2.05-1.64 16-12.923 16-24.82C32 7.385 24.923.103 16.103 0zm0 23.18a8.27 8.27 0 0 1-8.308-8.308 8.27 8.27 0 0 1 8.308-8.308 8.27 8.27 0 0 1 8.308 8.308 8.27 8.27 0 0 1-8.308 8.308z" fill="#07588c"/></svg>',
                svgURL = 'data:image/svg+xml;base64,' + btoa(icon),
                mySVGIcon = L.icon( {
                    iconUrl: svgURL,
                    iconSize: [35, 44],
                    iconAnchor: [17, 44]
                });
                lMap.mapDOM = L.map(lMap.modalId, {
                    gestureHandling: true,
                    attributionControl: !window._d.isRTL
                }).setView(coords, 15);

            L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank">CARTO</a>'
            }).addTo(lMap.mapDOM);

            if (window._d.isRTL) {
                lMap.mapDOM.zoomControl.setPosition('bottomleft');
                lMap.mapDOM.addControl(new L.Control.Fullscreen().setPosition('topleft'));
                L.control.attribution({
                    position: 'bottomright'
                }).addTo(lMap.mapDOM);
            } else {
                lMap.mapDOM.zoomControl.setPosition('bottomright');
                lMap.mapDOM.addControl(new L.Control.Fullscreen().setPosition('topright'));
            }

            L.marker(coords, {icon: mySVGIcon}).addTo(lMap.mapDOM);
        }
    },
    openModal: function() {
        var mWindow = $('#'+lMap.modalId+'Modal'),
            mBody = $('.map-modal-body');

        mWindow.fadeIn(400);
        $('body').addClass('modal-open');
        mBody.show();

        if (!lMap.existingModals.includes(lMap.modalId)) {
            lMap.render();
            lMap.existingModals.push(lMap.modalId);
        }
    },
    closeAction: function() {
        $(document).on('keyup', function(e) {
            if (e.keyCode === 27) {
                $('.map-modal-close').trigger('click');
            }
        });

        $('.map-modal-close').on('click', function(e) {
            e.preventDefault();
            lMap.close();
        });
    },
    close: function() {
        $('.map-modal').fadeOut(400, function() {
            if (!lMap.multipleModals) {
                $('body').removeClass('modal-open');
            }
            $('.map-modal-body').hide();
        });
    }
};
